<template>
  <div v-loading="loading">
    <el-table
      border
      v-if="!loading"
      :cell-style="cCellStyle"
      :height="windowHeight - 160"
      :data="users"
    >
      <el-table-column
        label="Name"
        fixed
        sortable
        prop="firstName"
        min-width="150"
      >
        <template slot-scope="scope">{{ getFullName(scope.row) }}</template>
      </el-table-column>
      <el-table-column
        label="Class"
        :fixed="$mq === 'xs' ? false : 'left'"
        sortable
        prop="level.o_id"
        align="center"
        :filters="levelFilters"
        :filter-method="levelFilter"
        min-width="100"
      >
        <template slot-scope="scope">{{ scope.row.level.name }}</template>
      </el-table-column>
      <el-table-column
        v-for="obv in (events == null ? [] : events)"
        align="center"
        :key="obv.o_id"
        :label="obv.date"
        width="110"
      >
        <template slot-scope="scope">
          <span v-if="obv.attendance[scope.row.o_id] != null">
            <span
              :style="cAttendanceColor(obv.attendance[scope.row.o_id].attendance_type.short)"
            >{{ obv.attendance[scope.row.o_id].attendance_type.short }}</span>
          </span>
        </template>
      </el-table-column>
      <el-table-column
        :fixed="$mq === 'xs' ? false : 'right'"
        align="center"
        label="Total"
        sortable
        prop="total"
        width="120"
      >
        <template slot-scope="scope">{{ attendanceTotal(scope.row.o_id) }}%</template>
      </el-table-column>
    </el-table>
    <div class="clearfix" v-loading="terms == null">
      <el-row type="flex" style="margin-top: 8px;" class="bottom">
        <el-select
          v-if="terms != null"
          style="width: 100%; margin-right: 8px;"
          v-model="selectedTerms"
          multiple
          placeholder="Select Terms"
        >
          <el-option v-for="item in terms" :key="item.term" :label="item.name" :value="item.term"></el-option>
        </el-select>
        <el-button
          :disabled="selectedTerms.length == 0"
          class="button"
          @click="downloadChart(type)"
          type="info"
          size="small"
          icon="el-icon-download"
        ></el-button>
      </el-row>
    </div>
  </div>
</template>

<script>
import Papa from "papaparse";
import {mapFields} from "vuex-map-fields";

export default {
    props: ["eventTypeId"],
    data() {
        return {
            jsonFields: {},
            jsonData: [],
            events: null
        };
    },
    watch: {
        selectedTerms() {
            this.getEvents();
        },
        eventTypes() {
            this.getEvents();
        },
        eventTypeId() {
            this.events = null;
            this.getEvents();
        }
    },
    computed: {
        ...mapFields([
            "user",
            "users",
            "levels",
            "terms",
            "selectedTerms",
            "eventTypes",
            "attendanceTypes"
        ]),
        loading() {
            return !(
                this.events != null &&
        this.eventTypes != null &&
        this.attendanceTypes != null
            );
        },
        levelFilters() {
            var t = [];
            if (this.levels == null) return t;
            this.levels.map((level) => {
                t.push({text: level.name, value: level.o_id});
            });
            return t;
        }
    },
    created() {
        if (!this.$store.getters.hasPermission(["All", "Records"]))
            this.$router.push("/admin");
    },
    mounted() {
        if (this.terms == null) this.$store.dispatch("pullTerms");
        if (this.levels == null) this.$store.dispatch("pullLevels");
        if (this.eventTypes == null) this.$store.dispatch("pullEventTypes");
        if (this.attendanceTypes == null)
            this.$store.dispatch("pullAttendanceTypes");
    },
    methods: {
        attendanceTotal(userId) {
            var t = this.events.length;
            var i = this.events.filter((event) => {
                if (event.attendance[userId] != null) {
                    var type = event.attendance[userId].attendance_type.short;
                    return type == "AC" || type == "E" || type == "X";
                }
                return false;
            }).length;
            return Number(Math.round(i / t * 100 + "e2") + "e-2");
        },
        downloadChart() {
            this.jsonData = [];
            this.users.forEach((user) => {
                var t = {};
                t.name = this.getFullName(user);
                t.total = this.attendanceTotal(user.o_id) + "%";
                this.events.forEach((event) => {
                    t[event.date] =
            event.attendance[user.o_id] != null
                ? event.attendance[user.o_id].attendance_type.short
                : " ";
                });
                this.jsonData.push(t);
            });
            var w = Papa.unparse(this.jsonData);

            var data, filename, link;
            if (w == null) return;

            filename = ".csv";
            this.selectedTerms.forEach((term) => {
                filename = "_" + term + filename;
            });

            filename =
        this.eventTypes.find((element) => {
            return element.o_id == this.eventTypeId;
        }).name + filename;

            var t;
            if (!w.match(/^data:text\/csv/i)) {
                t = "data:text/csv;charset=utf-8," + w;
            }
            data = encodeURI(t);

            if (navigator.msSaveBlob) {
                var blob = new Blob([w], {type: "text/csv;charset=utf-8;"});
                navigator.msSaveBlob(blob, filename);
            } else {
                link = document.createElement("a");
                link.setAttribute("href", data);
                link.setAttribute("download", filename);
                link.click();
            }
        },

        getEvents(arg) {
            if (this.selectedTerms == null || this.selectedTerms.length == 0) return;
            var url = "/api/v1/attendance/chart?";
            this.selectedTerms.forEach((term) => {
                url += "terms[]=" + term + "&";
            });
            if (this.eventTypeId == 0) this.eventTypeId = arg;
            url += "event_type=" + this.eventTypeId;
            this.axios
                .get(url, {
                    headers: {"Content-Type": "application/json"},
                    credentials: "same-origin"
                })
                .then((response) => {
                    this.events = response.data;
                })
                .catch((err) => {
                    this.$message({
                        showClose: true,
                        message: err.response.data.errors,
                        type: "error"
                    });
                });
        },

        levelFilter(value, row) {
            return row.level.o_id === value;
        },

        cCellStyle(row) {
            if (row.column.label == "Total") {
                if (row.row.total) {
                    if (row.row.total < 80) {
                        return "background-color:rgba(234, 108, 130, 0.6);";
                    } else if (row.row.total < 90) {
                        return "background-color:rgba(243, 184, 97, 0.6);";
                    }
                    return "background-color:rgba(104, 158, 241, 0.6);";
                }
            }
        },

        cAttendanceColor(type) {
            if (type == "AC" || type == "E" || type == "X") {
                return "color: #599EF8;";
            } else if (type == "P") {
                return "";
            }
            return "color: red;";
        },

        cUsersByClass(id) {
            return this.users.filter((user) => user.level.o_id == id);
        }
    }
};
</script>
